module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "name",
      "description": "图标类型",
      "code": _vm.name_code
    },
    slot: "left"
  }, [_c('Icon', {
    attrs: {
      "name": 'heart'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "name": 'star'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "name": 'tag'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "size",
      "description": "图标大小",
      "code": _vm.size_code
    },
    slot: "right"
  }, [_c('Icon', {
    attrs: {
      "size": 16,
      "name": 'enviroment'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "size": 24,
      "name": 'enviroment'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "size": 32,
      "name": 'enviroment'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "图标颜色",
      "code": _vm.color_code
    },
    slot: "left"
  }, [_c('Icon', {
    attrs: {
      "color": 'red',
      "name": 'search'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "color": '#00a0e9',
      "name": 'search'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "color": 'rgba(33, 66, 99, 0.6)',
      "name": 'search'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "rotate",
      "description": "旋转",
      "code": _vm.rotate_code
    },
    slot: "right"
  }, [_c('Icon', {
    attrs: {
      "rotate": true,
      "name": 'loading'
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0820084d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Icon.vue
// module id = 618
// module chunks = 0